<template>
  <div class="picture-preview-swiper">
    <div class="mask"></div>
    <div class="preview-pic">
      <div class="activeName">
        {{coverPicList[subscript].name}}&nbsp;&nbsp;({{subscript+1}}/{{coverPicList.length}})
      </div>
      <!-- 预览大图 -->
      <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
        <template v-for="(item,index) in coverPicList">
          <swiper-slide :key="item.url">
            <div
              :style="{backgroundImage: `url(${prefix}${item.url})`,transform:subscript===index?`rotate(${degrees*90}deg)`:'rotate(0deg)'}"
              class="bigImg">
            </div>
          </swiper-slide>
        </template>
        <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
        <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
      </swiper>
      <div class="tips">
        <img @click.stop="rotate" src="./assets/preview-pic/016.png" alt="">
        <span @click.stop="viewOriginalImage">查看原图</span>
        <span @click.stop="downLoadActivePic"><i class="el-icon-download"></i>下载</span>
      </div>
      <!-- 缩略图 -->
      <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
        <template v-for="(item,index) in coverPicList">
          <swiper-slide :class="{'thumbs-active':subscript===index}" :key="item.url">
            <div class="item" @click="thumbClick(index)">
              <img class="thumbnail" :src="prefix+item.url" alt="">
            </div>
            <div class="imgName">{{item.name}}</div>
          </swiper-slide>
        </template>
      </swiper>
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import router from '@/router/index.js'
export default {
  name: 'tbh-preview-pictuere-swipper',
  props: ['data'],
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      coverPicList: [],
      swiperOptionTop: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        on: {
          slideChange: () => {
            this.subscript = this.$refs.swiperTop.swiper.realIndex
            this.degrees = 0
          }
        }
      },
      swiperOptionThumbs: {
        slidesPerView: 5
      },
      prefix: sessionStorage.getItem('ossDownloadUrl'),
      degrees: 0,
      subscript: 0
    }
  },
  created () {
    let fileLists = JSON.parse(sessionStorage.getItem('coverPicList'))
    let allowType = ['png', 'jpg', 'jpeg', 'gif']
    let flag = 0
    this.coverPicList = fileLists.filter((c, index) => {
      if (c.url === this.data.src) {
        flag = index
      }
      let type = c.name.split('.').pop()
      return !c.loading && allowType.some(n => n === type.toLocaleLowerCase())
    })
    this.$nextTick(() => {
      this.swiperFlag = true
      setTimeout(() => {
        this.$refs.swiperTop.swiper.slideTo(flag, 0)
      }, 0)
    })
  },
  watch: {
    'subscript' (val) {
      let swiperThumbsIndex = this.$refs.swiperThumbs.swiper.realIndex
      if (swiperThumbsIndex > val) {
        this.$refs.swiperThumbs.swiper.slideTo(val, 1000)
      } else if (swiperThumbsIndex + 5 === val) {
        this.$refs.swiperThumbs.swiper.slideTo(swiperThumbsIndex + 1, 1000)
      } else if (swiperThumbsIndex + 4 < val) {
        this.$refs.swiperThumbs.swiper.slideTo(val, 1000)
      }
    }
  },
  methods: {
    downLoadActivePic () {
      let url = this.coverPicList[this.subscript].url
      window.open(`${sessionStorage.getItem('ossDownloadUrl')}${url}`)
    },
    viewOriginalImage () {
      let href = router.resolve({name: 'tbhImagePreview',
        query: {
          src: `${sessionStorage.getItem('ossDownloadUrl')}${this.coverPicList[this.subscript].url}`,
          title: '查看原图'
        }}).href
      window.open(href, '_blank')
    },
    rotate () {
      this.degrees++
      if (this.degrees === 4) {
        this.degrees = 0
      }
    },
    closePreview () {
      this.degrees = 0
      this.$emit('closePreview')
    },
    thumbClick (index) {
      this.$refs.swiperTop.swiper.slideTo(index, 1000)
    }
    // getDownLoadUrl (path) {
    //   return path.includes('USER') ? sessionStorage.getItem('downloadUrl') : sessionStorage.getItem('cdnDownloadUrl')
    // }
  },
  beforeDestroy () {
    sessionStorage.removeItem('coverPicList')
  }
}
</script>

<style lang="scss">
  .picture-preview-swiper{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 9997;
    .mask{
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: .5;
      background: #000;
      z-index: 9998;
      color: #ffffff;
    }
    .preview-pic{
      z-index: 9999;
      position: absolute;
      left:50%;
      top:50%;
      transform: translate(-50%,-50%);
      width: 1500px;
      text-align: center;
      .swiper {
        .swiper-slide {
          background-size: cover;
          background-position: center;
          .thumbnail{
            width: 100%;
            height: 100%;
          }
          .bigImg{
            width: 88%;
            height: 88%;
            margin: 0 auto;
            margin-top: 3%;
            position: relative;
            background-position: center;
            background-repeat: no-repeat;
            background-size: contain;
            .img{
              width: 100%;
              height: auto;
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%,-50%);
            }
          }
        }
        &.gallery-top {
          height: 600px;
          width: 100%;
        }
        &.gallery-thumbs {
          height: 130px;
          box-sizing: border-box;
          width: 600px;
        }
        &.gallery-thumbs .swiper-slide {
          width: 20%;
          height: 100%;
          opacity:1;
          box-sizing: border-box;
          .item{
            width: 100%;
            height: 100px;
            padding: 5px;
          }
          .imgName{
            display: none;
            color: #fff;
          }
        }
        &.gallery-thumbs .thumbs-active {
          .imgName{
            display: block;
            color: #fff;
            font-size: 12px;
          }
          .item{
            padding: 4px;
            border: 1px solid #55ACF1;
          }
        }
      }
      .tips{
        height: 40px;
        box-sizing: border-box;
        padding:5px 100px ;
        text-align: right;
        color: #ffffff;
        img:hover{
          content:url('./assets/preview-pic/017.png');
        }
        span,i{
          margin-left: 15px;
          cursor: default;
        }
        span:hover,i:hover{
          color: #5cb6ff;
        }
      }
      .del{
        position: absolute;
        right: 65px;
        top: 0;
        width: 32px;
        height: 32px;
      }
      .activeName{
        width: 100%;
        padding: 0 100px;
        text-align: left;
        color: #ffffff;
      }
      .swiper-container{
        .swiper-button-prev {
          background-image: url("./assets/preview-pic/015.png");
          width: 51px;
          height: 51px;
          background-repeat: no-repeat;
          background-size: cover;
        }
        .swiper-button-prev:hover{
          background-image: url("./assets/preview-pic/014.png");
        }
        .swiper-button-next{
          background-image: url("./assets/preview-pic/012.png");
          width: 51px;
          height: 51px;
          background-repeat: no-repeat;
          background-size: cover;
        }
        .swiper-button-next:hover{
          background-image: url("./assets/preview-pic/013.png");
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/globalComponent/publicPreview/components/tbh-preview-pictuere-swipper.vue